import * as React from 'react';
import Revision from '../../../models/Revision';
import { useHistory } from 'react-router-dom';
import TertiaryButton from '../../common/tertiary-button';
import Paths from '../../../models/enums/paths';
import useHelpDocumentManagement from '../../../hooks/useHelpDocumentManagement';
import usePaginatedRevisions from '../../../hooks/usePaginatedRevisions';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

interface Props {
  clientId: number;
  revision: Revision;
  isGlobal: boolean;
  setErrorMessage: (message: string) => void;
  setSuccessMessage: (message: string) => void;
}

/**
 * Individual row for revisions
 */
const RevisionRow = ({ clientId, revision, isGlobal, setErrorMessage, setSuccessMessage }: Props) => {
  const { publishClientDocument, publishGlobalDocument } = useHelpDocumentManagement();
  const { updatePublishedRevision } = usePaginatedRevisions();
  const history = useHistory();

  /**
   * Redirects to edit an individual revision
   */
  const redirectToEditRevision = () => {
    if (!isGlobal) {
      history.push(
        `${Paths.EditClientHelpDocument.replace(':clientId', clientId.toString()).replace(
          ':snippetId',
          revision.snippetId.toString()
        )}/revisions`
      );
    } else {
      history.push(`${Paths.EditGlobalHelpDocument.replace(':snippetId', revision.snippetId.toString())}/revisions`);
    }
  };

  /**
   * Publishes the selected revision
   */
  const publishRevision = () => {
    if (isGlobal) {
      publishGlobalDocument(revision.snippetId)
        .then(() => {
          setSuccessMessage(`Help document is now published`);
          updatePublishedRevision(revision.snippetId);
        })
        .catch(err => setErrorMessage(err.responseJSON.message));
    } else {
      publishClientDocument(Number(clientId), revision.snippetId)
        .then(() => {
          setSuccessMessage(`${revision.snippetId} is now published`);
          updatePublishedRevision(revision.snippetId);
        })
        .catch(err => setErrorMessage(err.responseJSON.message));
    }
  };

  return (
    <tr>
      <td>{revision.revNumber}</td>
      <td title={revision.modifiedBy}>{revision.modifiedBy}</td>
      <td title={revision.modifiedTimeFriendly}>{revision.modifiedTimeFriendly}</td>
      <td>
        <TertiaryButton text="Edit" title="" handleClick={redirectToEditRevision} />
      </td>
      <td>
        <TertiaryButton text="Publish" title="" handleClick={publishRevision} />
        {revision.isActive && (
          <CheckCircleIcon
            style={{ position: 'absolute', color: '#65b500', height: '18px', width: '18px', marginLeft: '5px' }}
          />
        )}
      </td>
    </tr>
  );
};

export default RevisionRow;
